import { motion, useScroll, useSpring } from "framer-motion";

/**
 * ReadingProgress — a thin bar that fills as the reader scrolls the page.
 * Sits above all content; subtle sage tone in keeping with the palette.
 */
export const ReadingProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });
  return (
    <motion.div
      data-testid="reading-progress"
      className="fixed top-0 left-0 right-0 h-[3px] bg-sage-500 origin-left z-[60]"
      style={{ scaleX }}
      aria-hidden="true"
    />
  );
};

export default ReadingProgress;
